import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

export default function CookiePolicyComponent() {

    return (
        <>
            <Header isHomePage={false} onGiftToggle={() => { }} isGiftMode={false}/>
            <div class="container">
                <div class="row">
                    <div id="ot-sdk-cookie-policy">
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}